export const suppliersListingRoutes = [
  {
    path: 'listing',
    name: 'suppliers-listing',
    component: () => import(/* webpackChunkName: "suppliers-listing" */ './SuppliersListing.vue')
  },
  {
    path: 'create',
    name: 'create-suppliers',
    component: () =>
      import(/* webpackChunkName: "new-supplier" */ '../new-supplier/NewSupplier.vue')
  }
];
